export default __webpack_public_path__ + "static/media/F1_4.a6da850d.png";